import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
} from "@angular/core";

@Component({
  selector: "app-history-modal",
  templateUrl: "./history-modal.component.html",
  styleUrls: ["./history-modal.component.scss"],
})
export class HistoryModalComponent implements OnInit, OnChanges {
  gridSize = { y: "300px", x: "auto" };
  loading = false;
  currentPageIndex = 1;
  currentPageSize = 10;

  @Input() total = 0;
  @Input() showModal = false;
  @Input() gridData = [];
  @Input() gridColumnList = [];
  @Input() gridColumnFields = [];
  @Input() modalTitle;
  @Input() widthConfig;
  @Output() closeModal = new EventEmitter<boolean>();
  @Output() pageDetailsChangeHandler = new EventEmitter();

  ngOnInit() {
    this.loading = true;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      changes.gridData &&
      changes.gridData.currentValue !== changes.gridData.previousValue
    ) {
      this.gridData = changes.gridData.currentValue;
      this.loading = false;
    }
  }

  handleCancel() {
    this.closeModal.emit(false);
  }

  onPageIndexChange(number) {
    if (this.pageDetailsChangeHandler)
      this.pageDetailsChangeHandler.emit([number, this.currentPageSize]);
  }

  onPageSizeChange(pageSize) {
    if (this.pageDetailsChangeHandler)
      this.pageDetailsChangeHandler.emit([this.currentPageIndex, pageSize]);
  }
}
